import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { GrupoService } from '../../services/grupo.service';
import { EmpresaService } from '../../services/empresa.service';
import { FacturacionService } from '../../services/facturacion.service';
import { Grupo } from '../../models/grupo';
import { Facturacion } from '../../models/facturacion';

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.css'],
	providers: [GrupoService, EmpresaService, FacturacionService]
})
export class DashboardComponent implements OnInit {

	public identity;
	public token;
	public status;
	public message_success;
	public message_error;
	public message_alert;
	public section;
	public empresas;
	public facturacion: Facturacion;
	public grupo: Grupo;

	constructor(
		private _route: ActivatedRoute,
		private _router: Router,
		private _grupoService: GrupoService,
		private _empresaService: EmpresaService,
		private _facturacionService: FacturacionService
	) {
		this.identity = this._grupoService.getIdentity();
		this.token = this._grupoService.getToken();
		this.grupo = new Grupo(1, 1, '', '', '', '', '', '', '', '', 1);
		this.facturacion = new Facturacion(0, 1, '', '', '', '', '', '', '', '', '');
	}

	ngOnInit() {
		if (!this.identity) {
			this._router.navigate(['login']);
		}

		if (this.identity['rol_id'] == '1' || this.identity['rol_id'] == '2') {
			this._router.navigate(['login']);
		}

		this.getSection();
		this.getGrupo();
		this.getEmpresasByGrupo();
	}

	getSection() {
		this._route.params.subscribe(params => {
			// convertir a entero
			let section = params['section'];
			this.section = section;
		});
	}

	getGrupo() {
		this._grupoService.getGrupo(this.token, this.identity['sub']).subscribe(
			response => {
				// Obtener el token 
				if (response.status == 'success') {
					this.grupo = response.grupo;
				} else {
					alert('No se pueden cargar los datos porque usted no tiene conexión a internet');
				}
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				} else {
					this.message_error = error;
				}

			}
		);
	}

	getEmpresasByGrupo() {
		this._empresaService.getEmpresasByGrupo(this.token).subscribe(
			response => {
				// Obtener el token 
				if (response.status == 'success') {
					this.empresas = response.empresas;
				}
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				} else {
					this.empresas = null;
					this.message_error = error;
				}
			}
		);
	}

}
